import React from 'react';
import { Flex, Typography } from 'antd';

import { AutobroadcastFormComponentProps } from '../../service/autoBroadcast.interface';
import { timeVariants } from '../../utils/fields';
import * as S from '../../styles/autobroadcast.styles';

const { Text } = Typography;

export const AutoBroadcastPeriodSelect = ({
    title,
    fieldName,
    formik,
}: AutobroadcastFormComponentProps) => {
    return (
        <Flex gap={8} vertical>
            <Text>{title}</Text>
            <S.Select
                value={formik?.values?.send_after}
                placeholder={'Выбрать'}
                onChange={value => {
                    formik.setFieldValue(fieldName, value);
                }}
                options={timeVariants}
            />
        </Flex>
    );
};
